import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  round,
  convertHexToDecimal,
  convertLoopToIcx,
} from '../utils/Conversions.js';
import { renderIcon } from '../utils/ShowIcons';

import { useIconSwapService } from './IconSwapService.jsx';

import blankLogos from '../images/BlankLogos.png';
import noTransactionDescription from '../images/NoTransactionDescription.png';
import noTransactionPrice from '../images/NoTransactionsPrice.png';

export const CompletedSwapsPanel = () => {
  const { address, getCompletedSwaps, tokens } = useIconSwapService();
  const [completedSwaps, setCompletedSwaps] = useState([]);
  const [hoverComponent, setHoverComponent] = useState<string>();

  useEffect(() => {
    getWindowDimensions();
    if (!address) return;
    const getSwaps = async () => {
      // @ts-ignore
      const swaps = await getCompletedSwaps();
      setCompletedSwaps(swaps);
    };

    getSwaps();
  }, [address]);

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  };
  const { innerWidth: width } = window;

  const getValue = (loopValue: string) => {
    const maker = convertLoopToIcx(convertHexToDecimal(loopValue));
    return maker;
  };

  const renderCompletedSwaps = () => {
    if (!completedSwaps || completedSwaps.length === 0) {
      return (
        <NonePendingWrapper>
          <TableRow>
            <NonePendingImage src={blankLogos} alt="none pending" />
            <SecondRowWrapper>
              <NonePendingDescriptionImage
                src={noTransactionDescription}
                alt="none pending"
              />
              <NonePendingAmountImage
                src={noTransactionPrice}
                alt="none pending"
              />
            </SecondRowWrapper>
          </TableRow>
          <TableRow>
            <NonePendingImage src={blankLogos} alt="none pending" />
            <SecondRowWrapper>
              <NonePendingDescriptionImage
                src={noTransactionDescription}
                alt="none pending"
              />
              <NonePendingAmountImage
                src={noTransactionPrice}
                alt="none pending"
              />
            </SecondRowWrapper>
          </TableRow>
          <NonePending>
            <NonePendingText>
              You currently don’t have any completed swaps. Once you do, they’ll
              appear here.
            </NonePendingText>
          </NonePending>
        </NonePendingWrapper>
      );
    }
    return completedSwaps.map((swap: any) => {
      if (!tokens) return 0;
      const tokensArray = Object.entries(tokens);
      tokensArray.map((token) => {
        if (swap.maker.contract === token[0]) {
          swap.makerToken = token[1];
        }
        if (swap.taker.contract === token[0]) {
          swap.takerToken = token[1];
        }
      });
      const price = round(swap.maker.amount / swap.taker.amount, 5);
      return hoverComponent === swap.id && width > 414 ? (
        <Link
          to={`/makeSwap/${
            swap.makerToken.symbol !== 'ICX'
              ? swap.makerToken.symbol
              : swap.takerToken.symbol
          }/${convertHexToDecimal(swap.id)}`}
          style={{ textDecoration: 'none' }}
          key={swap.id}
        >
          <TableRowOnHover onMouseLeave={() => setHoverComponent('')}>
            <ItemIcon>
              <BottomIcon src={renderIcon(swap.takerToken.name)}></BottomIcon>
              <TopIcon src={renderIcon(swap.makerToken.name)}></TopIcon>
            </ItemIcon>
            <ItemTransaction>
              Swapped<span> </span>
              <BoldItemTransaction>
                {getValue(swap.maker.amount)} {swap.makerToken.symbol}
              </BoldItemTransaction>
              for<span> </span>
              <BoldItemTransaction>
                {swap.takerToken.symbol}
              </BoldItemTransaction>
            </ItemTransaction>
            <ItemPrice>{price}</ItemPrice>
          </TableRowOnHover>
        </Link>
      ) : (
        <Link
          to={`/makeSwap/${
            swap.makerToken.symbol !== 'ICX'
              ? swap.makerToken.symbol
              : swap.takerToken.symbol
          }/${convertHexToDecimal(swap.id)}`}
          style={{ textDecoration: 'none' }}
          key={swap.id}
        >
          <TableRow
            key={swap.id}
            onMouseEnter={() => setHoverComponent(swap.id)}
          >
            <ItemIcon>
              <BottomIcon src={renderIcon(swap.takerToken.name)}></BottomIcon>
              <TopIcon src={renderIcon(swap.makerToken.name)}></TopIcon>
            </ItemIcon>
            <ItemTransactionQuery>
              <ItemTransaction>
                Swapped
                <BoldItemTransaction>
                  {getValue(swap.maker.amount)} {swap.makerToken.symbol}
                </BoldItemTransaction>
                for
                <BoldItemTransaction>
                  {swap.takerToken.symbol}
                </BoldItemTransaction>
              </ItemTransaction>
              <ItemPrice>{price}</ItemPrice>
            </ItemTransactionQuery>
          </TableRow>
        </Link>
      );
    });
  };
  return (
    <CompletedSwapsWrapper>
      <PanelHeader>Your completed swaps</PanelHeader>
      <TableHeader>
        <Transaction>Transaction</Transaction>
        <Price>Price (ICX)</Price>
      </TableHeader>
      <TableBody>{renderCompletedSwaps()}</TableBody>
    </CompletedSwapsWrapper>
  );
};

export default CompletedSwapsPanel;

const CompletedSwapsWrapper = styled.div`
  width: 508px;
  height: 508px;
  background-color: #fff;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
  border-color: #e9ebec;
  border-style: solid;
  border-width: 0.5px;
  position: relative;
  @media (max-width: 375px) {
    width: 333px;
    height: 516px;
  }
`;

const PanelHeader = styled.h3`
  padding-top: 25px;
  margin-left: 28px;
  font-size: 26px;
  @media (max-width: 375px) {
    padding-top: 15px;
    margin-left: 20px;
    font-size: 19px;
  }
  font-family: 'Avenir Next';
  font-weight: 600;
`;

const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 18px;
  padding-left: 47px;
  padding-right: 31px;
  padding-bottom: 20px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e9ebec;
  @media (max-width: 375px) {
    width: 335px;
    font-size: 15px;
    margin-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
  }
`;

const TableBody = styled.div`
  padding-right: 30px;
  height: 378px;
  overflow: scroll;
`;

const Transaction = styled.div``;

const Price = styled.div`
  margin-left: 253px;
  @media (max-width: 375px) {
    margin-left: 133px;
  }
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 14px;
  margin-left: 28px;
  margin-right: 28px;
  padding-bottom: 15px;
  padding-left: 19px;
  padding-right: 19px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e9ebec;
  @media (max-width: 375px) {
    width: 335px;
    flex-direction: column;
    margin-left: 20px;
    padding-left: 0;
    align-items: flex-start;
  }
`;

const NonePendingWrapper = styled.div``;

const SecondRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 375px) {
    display: flex;
    flex-direction: row;
  }
`;

const NonePendingImage = styled.img`
  height: 40px;
  @media (max-width: 375px) {
    height: 30px;
    margin-bottom: 10px;
  }
`;

const NonePendingDescriptionImage = styled.img`
  height: 16px;
  width: 237px;
  margin-left: 10px;
  @media (max-width: 375px) {
    width: 207px;
    margin-left: 0;
  }
`;

const NonePendingAmountImage = styled.img`
  height: 16px;
  width: 53px;
  margin-left: 46px;
  @media (max-width: 375px) {
    margin-left: 37px;
  }
`;

const NonePending = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 306px;
  height: 50px;
  margin-top: 31px;
  margin-left: 99px;
  @media (max-width: 375px) {
    width: 335px;
    margin-left: 0px;
    align-items: center;
  }
`;

const NonePendingText = styled.div`
  text-align: center;
  font-size: 15px;
  margin-bottom: 0;
  @media (max-width: 375px) {
    font-family: 'Avenir Next';
    font-size: 13px;
    font-weight: 500;
    height: 56px;
    width: 295px;
    color: #0e0d0e;
  }
`;

const ItemTransaction = styled.div`
  height: 16px;
  width: 250px;
  margin-top: 10px;
  margin-left: 13px;
  color: #000;
  font-family: 'Avenir Next';
  font-size: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (max-width: 375px) {
    margin-top: 0px;
    margin-left: auto;
  }
`;

const ItemPrice = styled.div`
  height: 16px;
  width: 53px;
  margin-top: 9px;
  margin-left: 43px;
  text-align: right;
  color: #000;
  @media (max-width: 375px) {
    margin-top: 0px;
    margin-left: 0px;
  }
`;

const ItemIcon = styled.div`
  position: relative;
  top: 0;
  left: 0;
  @media (max-width: 375px) {
    width: 60px;
  }
`;

const TopIcon = styled.img`
  height: 40px;
  width: 40px;
  position: absolute;
  right: 20px;
  @media (max-width: 375px) {
    right: auto;
    left: 0px;
    height: 30px;
    width: 30px;
  }
`;

const BottomIcon = styled.img`
  height: 40px;
  width: 40px;
  position: relative;
  top: 0;
  left: 0;
  @media (max-width: 375px) {
    left: 20px;
    height: 30px;
    width: 30px;
  }
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 33px;
  background-color: #faf8fa;
  @media (max-width: 375px) {
    flex-direction: column;
    height: 125px;
  }
`;

const FooterButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const BrowseButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  background-color: #007d81;
  height: 50px;
  width: 230px;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 4px;
  @media (max-width: 375px) {
    margin-top: 30px;
  }
`;

const ButtonText = styled.span`
  font-size: 16px;
  color: #fff;
`;

const TableRowOnHover = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 14px;
  margin-left: 15px;
  margin-right: 0px;
  padding-bottom: 15px;
  padding-left: 29px;
  padding-right: 29px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #e9ebec;
  box-shadow: 2px 2px 6px 2px #e9ebec;
  border-radius: 5px;
`;

const ItemTransactionQuery = styled.div`
  /* @media (max-width: 375px) { */
  display: flex;
  flex-direction: 'row';
  /* } */
`;

const BoldItemTransaction = styled.div`
  color: #000;
  font-family: 'Avenir Next';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  margin-left: 4px;
  margin-right: 4px;
  display: flex;
  flex-direction: row;
`;
